const ar = {
  "nav.home": "الرئيسية",
  "nav.services": "خدمات العملاء",
  "nav.services.website": "إنشاء المواقع",
  "nav.services.smm": "تسويق وسائل التواصل الاجتماعي",
  "nav.services.traffic": "باقات الزيارات / التسويق الرقمي",
  "nav.aiTools": "مركز أدوات الذكاء الاصطناعي",
  "nav.aiTools.reviews": "مراجعات أدوات الذكاء الاصطناعي",
  "nav.aiTools.guides": "الأدلة والدروس التعليمية",
  "nav.aiTools.landing": "صفحات الهبوط / العروض",
  "nav.about": "من نحن",
  "nav.profile": "الملف الشخصي",
  "nav.contact": "تواصل معنا",
  "nav.getStarted": "ابدأ الآن",
  "nav.language": "اللغة",

  "hero.eyebrow": "الوكالة الرقمية الأولى في أوغندا",
  "hero.title1": "حوّل حضورك",
  "hero.title2": "الرقمي",
  "hero.title3": "مع BientoMart",
  "hero.subtitle": "نبني مواقع ويب رائعة، وننمي تواجدك على وسائل التواصل الاجتماعي، ونربطك بأفضل أدوات الذكاء الاصطناعي لتعزيز أعمالك في شرق أفريقيا.",
  "hero.cta1": "استكشف الخدمات",
  "hero.cta2": "عرض أدوات الذكاء الاصطناعي",
  "hero.stat1.value": "+500",
  "hero.stat1.label": "مشروع مُنجز",
  "hero.stat2.value": "98%",
  "hero.stat2.label": "رضا العملاء",
  "hero.stat3.value": "24/7",
  "hero.stat3.label": "دعم متواصل",

  "services.label": "خدماتنا",
  "services.title": "كل ما تحتاجه للنجاح عبر الإنترنت",
  "services.subtitle": "من مواقع الويب الرائعة إلى استراتيجيات التواصل الاجتماعي القوية، نقدم نتائج ملموسة للشركات الأوغندية.",
  "services.learnMore": "اعرف المزيد",
  "services.websiteTitle": "إنشاء المواقع",
  "services.websiteDesc": "مواقع ويب مخصصة ومحسّنة لمحركات البحث تحوّل الزوار إلى عملاء.",
  "services.websiteFeature1": "تصميم متجاوب مخصص",
  "services.websiteFeature2": "محسّن لمحركات البحث من البداية",
  "services.websiteFeature3": "سريع وآمن",
  "services.websiteFeature4": "نظام إدارة المحتوى",
  "services.websiteFrom": "يبدأ من 299$",
  "services.smmTitle": "تسويق وسائل التواصل الاجتماعي",
  "services.smmDesc": "إدارة استراتيجية لوسائل التواصل الاجتماعي تبني علامتك التجارية وتنمّي جمهورك.",
  "services.smmFeature1": "إنشاء المحتوى وجدولته",
  "services.smmFeature2": "استراتيجية التفاعل مع الجمهور",
  "services.smmFeature3": "تحليلات وتقارير شهرية",
  "services.smmFeature4": "إدارة الإعلانات المدفوعة",
  "services.smmFrom": "يبدأ من 150$/شهر",
  "services.trafficTitle": "الزيارات والتسويق الرقمي",
  "services.trafficDesc": "حملات مستهدفة تجذب زيارات مؤهلة وتعزز إيراداتك عبر الإنترنت.",
  "services.trafficFeature1": "حملات إعلانات Google",
  "services.trafficFeature2": "إعلانات Facebook وInstagram",
  "services.trafficFeature3": "SEO وتحسين الكلمات المفتاحية",
  "services.trafficFeature4": "تحسين معدل التحويل",
  "services.trafficFrom": "يبدأ من 200$/شهر",

  "aiTools.label": "مركز أدوات الذكاء الاصطناعي",
  "aiTools.title": "اكتشف أدوات الذكاء الاصطناعي القوية",
  "aiTools.subtitle": "توصيات منتقاة ومراجعات صادقة لتعزيز إنتاجيتك.",
  "aiTools.readReview": "قراءة المراجعة الكاملة",
  "aiTools.rating": "التقييم",
  "aiTools.tryNow": "جرّبه الآن",
  "aiTools.textGenTitle": "أفضل مولّد نصوص بالذكاء الاصطناعي",
  "aiTools.textGenCategory": "إنشاء المحتوى",
  "aiTools.textGenDesc": "أنشئ مقالات وإعلانات ومحتوى تسويقي عالي الجودة في ثوانٍ مع Jasper AI.",
  "aiTools.imageGenTitle": "مولّد صور الذكاء الاصطناعي",
  "aiTools.imageGenCategory": "التصميم البصري",
  "aiTools.imageGenDesc": "أنشئ صوراً رائعة وصور منتجات ورسومات تسويقية مع Midjourney.",
  "aiTools.videoCreatorTitle": "صانع فيديو الذكاء الاصطناعي",
  "aiTools.videoCreatorCategory": "إنتاج الفيديو",
  "aiTools.videoCreatorDesc": "حوّل النصوص إلى فيديوهات احترافية في دقائق مع Pictory AI.",

  "about.label": "عن BientoMart",
  "about.title": "شريكك الرقمي الموثوق في أوغندا",
  "about.p1": "BientoMart هي المنصة الرائدة للخدمات الرقمية في أوغندا، تساعد الشركات وأصحاب الأعمال على بناء تواجد قوي عبر الإنترنت منذ عام 2020.",
  "about.p2": "يعمل فريقنا من المصممين والمسوقين وخبراء الذكاء الاصطناعي بلا كلل لتقديم نتائج استثنائية لعملائنا في جميع أنحاء شرق أفريقيا.",
  "about.p3": "نجمع بين أحدث التقنيات والمعرفة العميقة بالسوق المحلي لإنشاء استراتيجيات رقمية تتلاءم حقاً مع الجماهير الأوغندية.",
  "about.stat1.value": "+5",
  "about.stat1.label": "سنوات في العمل",
  "about.stat2.value": "+250",
  "about.stat2.label": "عميل راضٍ",
  "about.stat3.value": "+500",
  "about.stat3.label": "مشروع مُنجز",
  "about.cta": "وظّفنا اليوم",

  "testimonials.label": "قصص نجاح العملاء",
  "testimonials.title": "ماذا يقول عملاؤنا",
  "testimonials.subtitle": "نتائج حقيقية من شركات أوغندية حقيقية",

  "contact.label": "تواصل معنا",
  "contact.title": "ابدأ رحلتك الرقمية اليوم",
  "contact.subtitle": "هل أنت مستعد للارتقاء بأعمالك؟ دعنا نتحدث عن كيفية مساعدتك في النجاح عبر الإنترنت.",
  "contact.name": "الاسم الكامل",
  "contact.email": "البريد الإلكتروني",
  "contact.phone": "رقم الهاتف",
  "contact.service": "الخدمة المطلوبة",
  "contact.message": "رسالتك",
  "contact.send": "إرسال الرسالة",
  "contact.sending": "جارٍ الإرسال...",
  "contact.success": "شكراً! تم إرسال رسالتك. سنتواصل معك خلال 24 ساعة.",
  "contact.error": "حدث خطأ ما. يرجى المحاولة مجدداً.",
  "contact.address": "كمبالا، أوغندا",
  "contact.phoneValue": "+256 773515447",
  "contact.emailValue": "bientomart@gmail.com",
  "contact.hours": "الإثنين - الجمعة: 8:00 ص - 6:00 م EAT",
  "contact.optWebsite": "إنشاء المواقع",
  "contact.optSMM": "تسويق وسائل التواصل الاجتماعي",
  "contact.optTraffic": "باقات الزيارات",
  "contact.optAI": "استشارة أدوات الذكاء الاصطناعي",
  "contact.optOther": "أخرى",

  "footer.tagline": "تمكين الشركات الأوغندية من خلال الابتكار الرقمي والحلول المدعومة بالذكاء الاصطناعي.",
  "footer.services": "الخدمات",
  "footer.resources": "الموارد",
  "footer.newsletter": "ابقَ على اطلاع",
  "footer.newsletterDesc": "احصل على نصائح التسويق الرقمي وتحديثات أدوات الذكاء الاصطناعي في بريدك.",
  "footer.emailPlaceholder": "بريدك الإلكتروني",
  "footer.subscribe": "اشترك",
  "footer.copyright": "© 2026 BientoMart. جميع الحقوق محفوظة.",
  "footer.privacy": "سياسة الخصوصية",
  "footer.terms": "شروط الخدمة",
  "footer.blog": "المدونة",
  "footer.caseStudies": "دراسات الحالة",
  "footer.tutorials": "الدروس التعليمية",
  "footer.faq": "الأسئلة الشائعة",
  "footer.websiteCreation": "إنشاء المواقع",
  "footer.smm": "تسويق وسائل التواصل الاجتماعي",
  "footer.traffic": "باقات الزيارات",
  "footer.aiReviews": "مراجعات أدوات الذكاء الاصطناعي",

  "svc.hiresTitle": "وظّفنا لهذه الخدمة",
  "svc.hiresSubtitle": "هل أنت مستعد للبدء؟ تواصل معنا اليوم للحصول على استشارة مجانية.",
  "svc.getQuote": "احصل على عرض مجاني",
  "svc.whatsapp": "تحدث على واتساب",
  "svc.portfolioLabel": "أعمالنا",
  "svc.testimonialsLabel": "شهادات العملاء",
  "svc.processLabel": "طريقة عملنا",
  "svc.pricingLabel": "خطط الأسعار",
  "svc.basic": "أساسي",
  "svc.standard": "قياسي",
  "svc.premium": "بريميوم",
  "svc.popular": "الأكثر شعبية",
  "svc.perMonth": "/ شهر",
  "svc.oneTime": "دفعة واحدة",
  "svc.chooseplan": "اختر الخطة",

  "review.overview": "نظرة عامة سريعة",
  "review.features": "الميزات الرئيسية",
  "review.guide": "دليل خطوة بخطوة",
  "review.pricing": "التسعير",
  "review.verdict": "الحكم النهائي",
  "review.pros": "المميزات",
  "review.cons": "العيوب",
  "review.tryAffiliate": "جرّبه مجاناً",
  "review.getStarted": "ابدأ مع",
  "review.bestFor": "الأفضل لـ",
  "review.ourRating": "تقييمنا",
  "review.freeTrialAvail": "تجربة مجانية متاحة",
  "review.yes": "نعم",

  "profile.title": "عن بيينتو مارت",
  "profile.subtitle": "شريكك الرقمي الموثوق في أوغندا",
  "profile.aboutTitle": "تمكين الشركات من خلال الابتكار الرقمي",
  "profile.aboutP1": "بيينتو مارت هي المنصة الرائدة للخدمات الرقمية في أوغندا،，帮助企业和企业家建立强大的在线业务.",
  "profile.aboutP2": "我们的设计师、营销人员和人工智能专家团队不懈努力，为东非各地的客户提供卓越成果.",
  "profile.aboutP3": "我们将尖端技术与深入的本地市场知识相结合，打造真正引起乌干达受众共鸣的数字战略.",
  "profile.cta": "اتصل بنا",
  "profile.valuesTitle": "قيمنا الأساسية",
  "profile.valuesSubtitle": "指导我们一切工作的原则",
  "profile.teamTitle": "认识我们的团队",
  "profile.teamSubtitle": "打造 bientomart 的 passionate 人们",
  "profile.whyTitle": "为什么要选择 BientoMart",
  "profile.whySubtitle": "是什么让我们与众不同",
  "profile.why1Title": "快速交付",
  "profile.why1Desc": "我们始终按时交付项目,绝不拖延.",
  "profile.why2Title": "实惠定价",
  "profile.why2Desc": "为乌干达企业定制的有竞争力的价格.",
  "profile.why3Title": "全天候支持",
  "profile.why3Desc": "全天候支持，确保您的业务永不停止.",
  "profile.ctaTitle": "准备好改变您的业务了吗?",
  "profile.ctaSubtitle": "让我们一起创造一些非凡的东西,今天联系我们讨论您的项目",
  "profile.ctaButton": "开始",
  "profile.callUs": "联系我们",

  "portfolio.title": "معرض أعمالنا",
  "portfolio.subtitle": "استكشف مشاريعنا الناجحة看看我们如何帮助企业实现数字目标",
  "portfolio.projectsCompleted": "المشاريع المكتملة",
  "portfolio.happyClients": "العملاء السعداء",
  "portfolio.yearsExperience": "سنوات الخبرة",
  "portfolio.clientSatisfaction": "رضا العملاء",
  "portfolio.visitProject": "زيارة المشروع",
  "portfolio.industriesTitle": "الصناعات التي نخدمها",
  "portfolio.industriesSubtitle": "خبرتنا تمتد عبر صناعات متعددة، تقديم حلول مصممة لكل قطاع",
  "portfolio.ctaTitle": "هل أنت مستعد لبدء مشروعك؟",
  "portfolio.ctaSubtitle": "دعونا نخلق شيئًا مذهلاً معًا. تواصل معنا اليوم لمناقشة مشروعك",
  "portfolio.startProject": "ابدأ مشروعك",
  "portfolio.viewServices": "عرض خدماتنا",

  "nav.portfolio": "معرض الأعمال",
};

export default ar;
